import React, { useState } from 'react';
import { TypingTitle } from '../../agent/typing-title';
import type {
  ChatSeedChrome,
  ChatSeedChromeProps,
} from '../../chat-seed/types';

const NEW_WORKFLOW_SEED_HEADINGS = [
  'Have Coco build it for you, or edit your workflow',
  'Get Coco to build your workflow, or edit it yourself',
  'Ask Coco to build it, or edit your workflow',
  'Use Coco to build or edit your workflow',
] as const;

const EXISTING_WORKFLOW_SEED_HEADINGS = [
  'Have Coco edit it for you, or edit your workflow',
  'Get Coco to edit your workflow, or edit it yourself',
  'Ask Coco to edit it, or edit your workflow',
  'Use Coco to edit or chat about your workflow',
] as const;

function pickRandomHeading(mode: 'new' | 'existing'): string {
  return (
    (mode === 'new'
      ? NEW_WORKFLOW_SEED_HEADINGS
      : EXISTING_WORKFLOW_SEED_HEADINGS)[
      Math.floor(
        Math.random() *
          (mode === 'new'
            ? NEW_WORKFLOW_SEED_HEADINGS.length
            : EXISTING_WORKFLOW_SEED_HEADINGS.length)
      )
    ] ??
    (mode === 'new'
      ? NEW_WORKFLOW_SEED_HEADINGS[0]
      : EXISTING_WORKFLOW_SEED_HEADINGS[0])
  );
}

const WorkflowChatSeedHeading: React.FC<ChatSeedChromeProps> = ({ isNew }) => {
  const [heading] = useState(() =>
    pickRandomHeading(isNew === true ? 'new' : 'existing')
  );

  return <TypingTitle text={heading} className="mb-2" />;
};

export const workflowChatSeedChrome: ChatSeedChrome = {
  Heading: WorkflowChatSeedHeading,
};
